import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import Head from "next/head";

// core components
import Header from "components/Header/Header";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Link, Button } from "@material-ui/core";
import styles from "assets/jss/nextjs-material-kit/pages/landingPage.js";
import customStyles from "assets/jss/custom/customStyles.js";

const useStyles = makeStyles({
  ...styles,
  ...customStyles,
});

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default function ContentPage(props) {
  const dashboardRoutes = [];
  const { ...rest } = props;
  const classes = useStyles();

  const params = {
    title: "Kontakt",
    teaser:
      "Kontakt zu getasugar - Fragen zur Sugar Daddy Suche in Österreich, zu deiner Mitgliedschaft oder im Falle technischer Probleme",
  };

  return (
    <div>
      <Head>
        <title>{params.title} | getasugar - das Sugar Dating Portal</title>
        <meta name="description" content={params.teaser} />
      </Head>
      <Header
        color="primary"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        {...rest}
      />
      <div className={classes.main} style={{ marginTop: "3em" }}>
        <div className={classes.row}>
          <div className={classes.container}>
            <div className={classNames(classes.hasPaddingTop)}>
              <GridContainer
                justify="center"
                className={classNames(
                  classes.hasPaddingTop,
                  classes.contentContainer,
                  classes.hasShadow
                )}
              >
                <GridItem xs={12} key='title'>
                  <h2 className={classes.h2}>{params.title}</h2>
                </GridItem>

                <GridItem xs={12} key='faq'>
                  <h3>Häufig gestellte Fragen</h3>
                  <p>
                    Solltest du Fragen zu unserer Plattform haben so schau bitte
                    zuerst in unserem <Link href="/faq">FAQ Bereich</Link>. Hier
                    findest du Hilfestellungen zu den häufigsten Fragen rund um
                    getasugar. Die FAQ werden von uns laufend aktualisiert und
                    erweitert.
                  </p>

                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    href="/faq"
                  >
                    Zu den FAQ
                  </Button>
                </GridItem>

                <GridItem xs={12} style={{ paddingTop: "1em" }} key='email'>
                  <h3>Support per E-Mail</h3>
                  <p>
                    Falls du in den FAQ nicht fündig geworden bist oder ein
                    anderes Anliegen hast, sende uns bitte eine E-Mail.
                  </p>
                  <p>
                    Du erreichst unser Support-Team unter folgender Adresse:{" "}
                    <Link href="mailto: support@getasugar.de">
                      support@getasugar.de
                    </Link>
                  </p>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
